export const selectRegionPicker = (state) => state.regionPicker;
export const selectRegionPickerStatus = (state) => state.regionPicker.initialized;
